import { gql } from '@apollo/client';

export * from './transferCompanyOwnership.mutation.generated';

export const TRANSFER_COMPANY_OWNERSHIP = gql`
  mutation transferCompanyOwnership($userId: ID!) {
    transferCompanyOwnership(input: { userId: $userId }) {
      success
      errors
      user {
        id
        role
        name
        policy {
          update
          remove
          transferOwnership
        }
      }
    }
  }
`;
